module.exports = __webpack_public_path__ + "img/symbol_1.34b7eab6.png";